var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('multi-select-filter', {
    attrs: {
      "id": _vm.filterData.key + '-filter',
      "label": _vm.filterData.label,
      "current-set-value": _vm.selectedOptions,
      "get-value": _vm.getOptions,
      "multiple": true,
      "update-method": _vm.updateValue,
      "track-by": "key",
      "display-value": "title"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }